function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { useBuildStyleWithTheme } from "../ThemeProvider";
import { useMemo } from "react";
var buildStyle = function(theme, direction, flags) {
    var animation = theme.animation, font = theme.font, spacing = theme.spacing;
    var readingDirection = direction.readingDirection, start = direction.start;
    var typographyUpdates = flags.typographyUpdates;
    var _obj, _obj1, _obj2, _obj3;
    return {
        label: {
            base: _objectSpread({}, readingDirection, {
                color: font.color.neutral.base,
                display: 'block',
                position: 'relative',
                fontFamily: font.base.family,
                fontStyle: 'normal',
                fontWeight: font.base.weight.regular,
                letterSpacing: 'normal',
                lineHeight: font.lineHeight.base,
                margin: "0 0 ".concat(spacing[2], " 0"),
                padding: 0,
                textIndent: 0,
                textShadow: 'none',
                textTransform: 'none',
                verticalAlign: 'top'
            }),
            variant: {
                default: {
                    fontSize: font.base.size[3]
                },
                underline: (_obj = {}, _defineProperty(_obj, start.padding, spacing[5]), _defineProperty(_obj, "fontSize", font.base.size[4]), _defineProperty(_obj, "position", 'absolute'), _defineProperty(_obj, "top", 20), _defineProperty(_obj, "transition", "top ".concat(animation.duration[100], ", font-size ").concat(animation.duration[100], ", padding-left ").concat(animation.duration[100])), _obj),
                outline: (_obj1 = {}, _defineProperty(_obj1, start.padding, spacing[5]), _defineProperty(_obj1, "fontSize", font.base.size[4]), _defineProperty(_obj1, "position", 'absolute'), _defineProperty(_obj1, "top", 10), _defineProperty(_obj1, "transition", "top ".concat(animation.duration[100], ", font-size ").concat(animation.duration[100], ", padding-left ").concat(animation.duration[100])), _obj1),
                grid: {}
            },
            isAnimated: {
                base: {
                    fontSize: font.base.size[2]
                },
                variant: {
                    underline: {
                        top: 0
                    },
                    outline: {
                        top: '-10px'
                    },
                    grid: {},
                    default: {}
                }
            },
            isDisabled: {
                color: font.color.disabled
            },
            hasStartIcon: {
                default: {},
                grid: {},
                underline: _defineProperty({}, start.padding, "calc(".concat(spacing[8], " + ").concat(spacing[2], ")")),
                outline: _defineProperty({}, start.padding, "calc(".concat(spacing[8], " + ").concat(spacing[2], ")"))
            },
            hasStartIconAndIsRequired: {
                default: {},
                grid: {},
                underline: _defineProperty({}, start.padding, "calc(".concat(spacing[9], " + ").concat(spacing[2], ")")),
                outline: _defineProperty({}, start.padding, "calc(".concat(spacing[9], " + ").concat(spacing[2], ")"))
            }
        },
        required: {
            base: {
                color: font.color.danger.base,
                fontFamily: font.base.family,
                fontSize: font.base.size[6],
                fontStyle: 'normal',
                fontWeight: typographyUpdates ? font.base.weight.regular : font.base.weight.light,
                letterSpacing: 'normal',
                lineHeight: font.lineHeight.base,
                position: 'absolute',
                textDecoration: 'none !important',
                textIndent: 0,
                textShadow: 'none',
                textTransform: 'none',
                transition: "".concat(start.direction, " ").concat(animation.duration[100])
            },
            variant: {
                default: _defineProperty({}, start.direction, '-10px'),
                underline: (_obj2 = {}, _defineProperty(_obj2, start.direction, spacing[3]), _defineProperty(_obj2, "fontSize", font.base.size[3]), _obj2),
                outline: (_obj3 = {}, _defineProperty(_obj3, start.direction, spacing[3]), _defineProperty(_obj3, "fontSize", font.base.size[3]), _obj3),
                grid: {}
            },
            hasStartIcon: {
                default: {},
                grid: {},
                underline: _defineProperty({}, start.direction, "calc(".concat(spacing[8], " + ").concat(spacing[2], ")")),
                outline: _defineProperty({}, start.direction, "calc(".concat(spacing[8], " + ").concat(spacing[2], ")"))
            }
        }
    };
};
var useStyle = function(param) {
    var hasStartIcon = param.hasStartIcon, isAnimated = param.isAnimated, isDisabled = param.isDisabled, isRequired = param.isRequired, isRtl = param.isRtl, variant = param.variant;
    var ref9;
    var ref1 = (ref9 = useBuildStyleWithTheme(buildStyle, {
        isRtl: isRtl
    })) !== null && ref9 !== void 0 ? ref9 : {}, label = ref1.label, required = ref1.required;
    return useMemo(function() {
        var ref, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
        return {
            label: _objectSpread({}, label === null || label === void 0 ? void 0 : label.base, label === null || label === void 0 ? void 0 : (ref = label.variant) === null || ref === void 0 ? void 0 : ref[variant], isAnimated && (label === null || label === void 0 ? void 0 : (ref2 = label.isAnimated) === null || ref2 === void 0 ? void 0 : ref2.base), isAnimated && (label === null || label === void 0 ? void 0 : (ref3 = label.isAnimated) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.variant) === null || ref4 === void 0 ? void 0 : ref4[variant]), !isAnimated && variant !== 'default' && isDisabled && (label === null || label === void 0 ? void 0 : label.isDisabled), hasStartIcon && !isAnimated && (label === null || label === void 0 ? void 0 : (ref5 = label.hasStartIcon) === null || ref5 === void 0 ? void 0 : ref5[variant]), hasStartIcon && isRequired && !isAnimated && (label === null || label === void 0 ? void 0 : (ref6 = label.hasStartIconAndIsRequired) === null || ref6 === void 0 ? void 0 : ref6[variant])),
            required: _objectSpread({}, required === null || required === void 0 ? void 0 : required.base, required === null || required === void 0 ? void 0 : (ref7 = required.variant) === null || ref7 === void 0 ? void 0 : ref7[variant], hasStartIcon && !isAnimated && (required === null || required === void 0 ? void 0 : (ref8 = required.hasStartIcon) === null || ref8 === void 0 ? void 0 : ref8[variant]))
        };
    }, [
        label,
        variant,
        isAnimated,
        isDisabled,
        required,
        hasStartIcon,
        isRequired
    ]);
};
export default useStyle;
